export default "__VITE_ASSET__jEYknl4C__"